<template>
  <div class="relative flex">
    <div class="box !p-0 box-25 last:mr-0 relative w-full device_small">

      <div class="flex">
        <AeroQuickStatus :config="config" size="w-[75px] min-w-[75px] max-w-[75px]" />

        <div class="flex w-full flex-wrap ">

        </div>
      </div>
      <Device_Link
        v-if="
          $root.user.can([4,5], 'DEVICES.EDIT.edit_device') &&
          config?.deviceFamilly?.this_dev_id != undefined &&
          !$root.isMilestonePlugin
        "
        :dev_id="config.deviceFamilly.this_dev_id"
        CssClass="right-[15px]"
      />

    </div>
  </div>
</template>

<script>
import AeroQuickStatus from "@/partials/Device/Template/Aeroscope/AeroQuickStatus.vue";
import Device_Link from "@/partials/Device/Template/Device_Link.vue";

export default {
  name: "Device_Info_Aeroscope",
  components: {
    AeroQuickStatus,
    Device_Link,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
